import * as enums from './enums'
import * as langs from './langs'
import * as localStorage from './local-storage'
import * as urls from './urls'
import * as formats from './formats'
import * as claims from './claims'
import * as store from './store'

export default {
  enums,
  langs,
  localStorage,
  urls,
  formats,
  claims,
  store
}
